export default __webpack_public_path__ + "static/media/599.a21d0a4f.png";